<template>
    <!-- Карточка пользователя в спике -->
    <div :class="['journal_card px-4 py-4 list-item-component', edited && 'card_edited']">
        <div class="vx-row mb-4">
            <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col">
                <div class="lg:flex w-full lg:justify-between lg:items-center">
                    <div class="user_detail flex items-center">
                        <div class="user_name flex items-center">
                            <!-- Название -->
                            <vs-row class="md:hidden">
                                <vs-col vs-w="12">
                                    <h5 class="todo-title">{{item.discipline}}</h5>
                                </vs-col>
                                <vs-col vs-w="12" class="md:hidden">
<!--                                    <vs-chip  :color="statusColor">{{statusText}}</vs-chip>-->
                                    <vs-chip  color="danger">{{item.language.name}}</vs-chip>
                                    <vs-chip v-if="item.group_code != 99"  color="primary">{{item.group_code}} {{ $t('subgroup') }}</vs-chip>
                                    <vs-chip v-if="(item.start_date || item.end_date)" class="ml-2 hidden sm:inline-flex" color="primary">{{item.start_date}}</vs-chip>
                                    <vs-chip v-if="(item.start_date || item.end_date)" class="ml-2 hidden sm:inline-flex" color="primary">{{ item.end_date }}</vs-chip>
                                </vs-col>
                            </vs-row>
                            <h5 class="todo-title hidden sm:inline-flex">{{item.discipline}}</h5>
                            <!-- Статус -->
<!--                            <vs-chip class="ml-2  hidden sm:inline-flex" :color="statusColor">{{statusText}}</vs-chip>-->
                            <vs-chip class="ml-2  hidden sm:inline-flex" color="danger">{{item.language.name}}</vs-chip>
                            <vs-chip v-if="item.group_code != 99" class="ml-2 hidden sm:inline-flex" color="primary">{{item.group_code}} {{ $t('subgroup') }}</vs-chip>
                            <vs-chip v-if="(item.start_date || item.end_date)" class="ml-2 hidden sm:inline-flex" color="primary">{{item.start_date}}</vs-chip>
                            <vs-chip v-if="(item.start_date || item.end_date)" class="ml-2 hidden sm:inline-flex" color="primary">{{ item.end_date }}</vs-chip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full flex lg:items-center lg:justify-between journal_info">
                <!-- Информация о датах, группах и тд -->
                <div>
                    <div class="mb-1 item lg:flex items-center" v-if="item.plan_block_date">
                        <div class="label mr-1 font-medium">{{$t('scheduled_blocking')}}:</div>
                        <div class="val">{{item.plan_block_date}}</div>
                    </div>
                    <div class="mb-1 item lg:flex items-center" v-if="item.load_type">
                        <div class="label mr-1 font-medium">{{$t('load_type')}}:</div>
                        <div class="val">{{item.load_type.name}}</div>
                    </div>
                    <div class="mb-1 item lg:flex items-center" v-if="item.acad_periods.length">
                        <div class="label mr-1 font-medium">{{$t('academic_periods')}}:</div>
                        <div class="val">{{item.acad_periods[0].name}}</div>
                    </div>
                    <div class="mb-1 item lg:flex items-center" v-if="item.groups.length">
                        <div class="label mr-1 font-medium">{{$t('groups')}}:</div>
                        <div class="val">{{item.groups[0].name}}</div>
                    </div>
                    <div class="item lg:flex items-center" v-if="item.teachers.length">
                        <div class="label mr-1 font-medium">{{$t('teacher')}}:</div>
                        <div class="val">{{item.teachers[0].full_name}}</div>
                    </div>
                    <div class="item lg:flex items-center">
                        <vx-tooltip :text="$t('history')" position="right">
                            <feather-icon
                                @click="historyMoodle"
                                class="mt-2 text-primary cursor-pointer"
                                icon="ChevronsDownIcon"/>
                        </vx-tooltip>
                    </div>

                </div>

                <!-- Радиокнопки смены статуса -->
                <div class="lg:pr-8 status_actions">
                    <div class="mb-2">
                        <vs-radio
                            @change="changeStatus(false)"
                            :value="status.status"
                            :vs-name="`status_${ item.uid }`"
                            color="success"
                            :vs-value="false">
                                {{radioTextOpen}}
                        </vs-radio>
                    </div>
                    <div>
                        <vs-radio
                            @change="trueChangeStatus(true)"
                            :value="status.status"
                            :vs-name="`status_${ item.uid }`"
                            color="danger"
                            :vs-value="true">
                                {{radioTextClose}}
                        </vs-radio>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number
        },
        getBlocksNone:{

        }
    },
    components: {
    },
    data() {
        return {
            statusCheck: false, // Первичный статус журнала

        }
    },
    created: function() {
        // Получаем первичный статус журнала для вывода
        this.statusCheck = this.$store.state.block_journal.journalList[this.index].closed
    },
    computed: {
        ...mapGetters({
            start_date_end_date:'block_journal/start_date_end_date',
            check_element_check_true:'block_journal/check_element_check_true',
            check_element_check_false:'block_journal/check_element_check_false',
        }),
        status() {
            var obj = this.$store.state.block_journal.journalList[this.index]
            return {status:obj.closed,disable:false}
            // Получаем текущий статус журнала
            // var obj = this.$store.state.block_journal.journalList[this.index]
            // var date  = this.start_date_end_date
            // if(date){
            //     if (this.getBlocksNone){
            //         if(obj.start_date == null || obj.end_date == null){
            //             if (date.avto_blok && date.close){
            //                 return {status:true,disable:true}
            //             }else{
            //                 return {status:true,disable:false}
            //             }
            //         }else{
            //             if (date.avto_blok && date.close==false){
            //                 return {status:false,disable:true}
            //             }else{
            //                 return {status:false,disable:false}
            //             }
            //         }
            //     }else{
            //         if (date.avto_blok == false){
            //             return {status:obj.closed,disable:true}
            //         }else{
            //             return {status:obj.closed,disable:false}
            //         }
            //     }
            // }else{
            //     if (this.getBlocksNone){
            //         if(obj.start_date == null || obj.end_date == null){
            //             // if (date.avto_blok && date.close){
            //                 return {status:true,disable:false}
            //             // }else{
            //             //     return {status:true,disable:false}
            //             // }
            //         }else{
            //             // if (date.avto_blok && date.close==false){
            //             return {status:false,disable:false}
            //             // }else{
            //             //     return {status:false,disable:false}
            //             // }
            //         }
            //     }else{
            //         // if (date.avto_blok == false){
            //             return {status:obj.closed,disable:false}
            //         // }else{
            //         //     return {status:obj.closed,disable:false}
            //         // }
            //     }
            // }

        },
        edited() {
            // Получаем статус редактирования журнала
            return this.$store.state.block_journal.journalList[this.index].edited
        },
        radioTextOpen() {
            // Меняем название радиокнопки открытия
            if(!this.statusCheck)
                return this.$t('open')
            else
                return this.$t('open2')
        },
        radioTextClose() {
            // Меняем название радиокнопки закрытия
            if(this.statusCheck)
                return this.$t('closed')
            else
                return this.$t('close')
        },
        statusText() {
            // Выводим текст текущего статуса журнала
            if(!this.statusCheck)
                return this.$t('open')
            else
                return this.$t('closed')
        },
        statusColor() {
            // Выводим цвет текущего статуса журнала
            if(!this.statusCheck)
                return 'success'
            else
                return 'danger'
        }
    },
    methods: {
        async historyMoodle(){
            // this.popupActive = true
            this.$emit('GetUID',this.item.uid)
        },
        ...mapMutations({
            SET_START_DATE_END_DATE:'block_journal/SET_START_DATE_END_DATE'
        }),
        date(date) {
            return this.$moment(date).format('LLL')
        },
        async changeStatus(val) {
            // Изменяем в сторе статус выбранного журнала
            this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
            this.SET_START_DATE_END_DATE({avto_blok:true,close:false,check_hoe:true})
            // if(this.getBlocksNone){
            //
            //     this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
            //     this.SET_START_DATE_END_DATE({avto_blok:true,close:false,check_hoe:true})
            // }else{
            //     this.SET_START_DATE_END_DATE({avto_blok:false,close:false,check_hoe:true})
            //     await this.$http.post("/admin/journal_change_status/noneblock/", {obj:this.item,status:false})
            //         .then((res)=>{
            //             this.$vs.notify({
            //                 title: this.$t('succesful'),
            //                 color: "success"
            //             })
            //             this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
            //         })
            //         .catch(err=>{
            //             this.$vs.notify({
            //                 text:err.message_ru,
            //                 color: "danger",
            //             });
            //         });
            // }

        },
        async trueChangeStatus(val){
            if(this.getBlocksNone){

                this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
                this.SET_START_DATE_END_DATE({avto_blok:true,close:true,check_hoe:true})
                // await this.$http.post("/admin/journal_change_status/changestatus/", this.item)
                //     .then((res)=>{
                //         this.$vs.notify({
                //             title: this.$t('succesful'),
                //             color: "success"
                //         })
                //         this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
                //     })
                //     .catch(err=>{
                //         this.$vs.notify({
                //             text:err.message_ru,
                //             color: "danger",
                //         });
                //     });
            }else{
                this.SET_START_DATE_END_DATE({avto_blok:false,close:true,check_hoe:true})
                this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
                // await this.$http.post("/admin/journal_change_status/noneblock/", {obj:this.item,status:true})
                //     .then((res)=>{
                //         this.$vs.notify({
                //             title: this.$t('succesful'),
                //             color: "success"
                //         })
                //         this.$store.commit('block_journal/CHANGE_STATUS', {index: this.index, status: val})
                //     })
                //     .catch(err=>{
                //         this.$vs.notify({
                //             text:err.message_ru,
                //             color: "danger",
                //         });
                //     });
            }
            // obj = this.$store.state.block_journal.journalList[this.index]

        }
    }
}
</script>

<style scoped lang="scss">
.journal_card{
    transition: background 0.5s ease;
}
.card_edited{
    background: -webkit-gradient(linear,left top,right top,from(#fbfbd396),to(rgba(0,0,0,0)));
    background: -webkit-linear-gradient(left,#fbfbd396,rgba(0,0,0,0));
    background: -o-linear-gradient(left,#fbfbd396,rgba(0,0,0,0));
    background: linear-gradient(90deg,#fbfbd396,rgba(0,0,0,0));
}
@media only screen and (max-width: 900px) {
    .journal_info{
        flex-wrap: wrap;
        flex-direction: column-reverse;
    }
    .status_actions{
        padding-bottom: 8px;
    }
}
</style>
